/* @flow */

import type { CONFIRMATION_DATA_MODAL_TYPE } from '../../components/modal/confirmationModal/ConfirmationModal';
import type { EULA_DATA_MODAL_TYPE } from '../../components/modal/eulaModal/EulaModal';
import type { GAME_PROFILE_SELECT_DATA_MODAL_TYPE } from '../../components/modal/gameProfileSelectModal/GameProfileSelectModal';
import type { MESSAGE_MODAL_TYPE } from '../../components/modal/messageModal/MessageModal';
import type { NETGEM_API_PLAYINGHISTORY_ITEM } from '../../libs/netgemLibrary/v8/types/PlayingHistory';
import type { ReadOnlyKeyValuePair } from '../jsHelpers/types';

export type GamestreamToken = {
  configName: string,
  offers: Array<string>,
  token: string,
  url: string,
};

export enum ClientState {
  NotLoaded,
  Loaded,
  Loading,
}

export type SimpleProfile = {
  avatarUrl: string,
  nickname: string,
  profileId: string,
};

export type Profile = {
  avatar_alias: string,
  avatar_filename: string,
  content_rating: string,
  has_pin_code: boolean,
  nickname: string,
  parental_control: Array<string>,
  parental_control_activated: boolean,
  remaining_playtime: number,
  time_online: number,
  uid: string,
};

export type Profiles = Array<Profile>;

export type PromptSessionCloseType = (data: CONFIRMATION_DATA_MODAL_TYPE, ariaLabel: string) => void;
export type ShowEulaType = (data: EULA_DATA_MODAL_TYPE) => void;
export type ShowMessageType = (data: MESSAGE_MODAL_TYPE, ariaLabel: string) => void;
export type ShowGameProfileSelectType = (data: GAME_PROFILE_SELECT_DATA_MODAL_TYPE) => void;
export type UpdatePlayingHistoryItemType = (item: NETGEM_API_PLAYINGHISTORY_ITEM, itemId: string) => Promise<void>;

export const GamestreamStatus: ReadOnlyKeyValuePair<number> = Object.freeze({
  AlreadyPlaying: 612,
  MustApproveEula: 761,
  NoSubscriptionForGame: 635,
});

export type GamestreamApiErrorResponse = {
  error?: Error,
  gsStatusCode?: number,
  httpStatus?: number,
  message?: string,
};

export type GamestreamApiResponse = {
  ...GamestreamApiErrorResponse,
  response: any,
  status?: number,
};

export type TokensResponse = {
  ...GamestreamApiErrorResponse,
  refresh_token: string,
  token: string,
};

export type GamestreamSession = {
  ipTracker: string,
  sessionId: string,
  uri: string,
  useSsl?: boolean,
};

export type GamestreamEula = {
  eula?: string | null,
};

export type EulaResponse = { ...GamestreamApiResponse, ...GamestreamEula };

export type GamestreamGameConfig = {
  audio: string,
  'audio-port': number,
  bitrate: number,
  'client-type': string,
  'config-port': string,
  'default-virtualpad': string,
  'display-stats': string,
  'enable-stats': string,
  enc: string,
  'exit-btn': string,
  'extended-info-in-config': string,
  'force-default-gamepad': boolean,
  'frontend-language': string,
  'gamepad-max': number,
  'gamepad-min': number,
  height: number,
  'input-port': number,
  ip: string,
  key: string,
  loglevel: string,
  'microphone-ports': string,
  'mouse-local': string,
  'mouse-local-fullscreen': string,
  'network-bypass-proxy': string,
  'network-force-http': string,
  'network-game-mode': string,
  'network-is-wifi': string,
  'performance-setting': string,
  'screen-orientation': string,
  'touchscreen-enable': string,
  'use-encryption': string,
  'use-ipv6': string,
  version: string,
  'video-codec': string,
  'video-port': number,
  'virtualpad-assets': string,
  'virtualpad-config-normal': any,
  'virtualpad-config-touchscreen': any,
  'virtualpad-configs': ReadOnlyKeyValuePair<any>,
  'webcam-audio-port': number,
  'webcam-video-port': number,
  width: number,
};
